import styled from 'styled-components';

import { LabelS } from '#src/atoms/typography/index.tsx';
import { useIntlContext } from '#src/contexts/intl/index.ts';

type Props = {
  date: Date;
};

const Root = styled(LabelS)`
  white-space: nowrap;
`;

export const Since = ({ date }: Props) => {
  const { formatDistanceToNow } = useIntlContext();

  return <Root color="var(--c-nd-600)">{formatDistanceToNow(date)}</Root>;
};
